import script from './SdsContextMenuItem.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-context-menu-item sds-focus",class:{ 'sds-context-menu-item--danger': _vm.isDanger },attrs:{"type":"button","role":"menuitem","tabindex":"0"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"sds-context-menu-item--label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.iconName)?_c('SdsIcon',{staticClass:"sds-context-menu-item--icon",attrs:{"iconName":_vm.iconName,"aria-hidden":"true"}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-69780da8_0", { source: ".sds-context-menu-item[data-v-69780da8]{outline:0;border:none;width:100%;display:flex;padding:var(--space-padding-md) var(--space-padding-lg);align-items:center;justify-content:space-between;gap:24px;align-self:stretch;background-color:var(--system-bg-elevation-layer-1);color:var(--system-text-on-elevation-primary);cursor:pointer}.sds-context-menu-item[data-v-69780da8]:hover{background-color:var(--system-bg-elevation-layer-2)}.sds-context-menu-item[data-v-69780da8]:focus{z-index:1}.sds-context-menu-item--label[data-v-69780da8]{font-size:var(--system-label-large-bold-size);font-weight:600;line-height:var(--system-label-large-bold-line-height)}.sds-context-menu-item--danger[data-v-69780da8]{color:var(--system-text-on-elevation-danger-primary)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-69780da8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
